import React from "react";
import { IconProps } from "../icon";

export const ArrowNarrowUpIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path stroke={color} strokeLinecap="square" strokeWidth="2" d="M12 20V4m0 0l-6 6m6-6l6 6" />
  </svg>
);
